class QuickWinIframeMessageProcessor {
   getIframeElementFromSourceWindow(sourceWindow) {
      const iframeElements = document.getElementsByTagName("iframe");
      for (let iframeElement of iframeElements) {
         if (iframeElement.contentWindow === sourceWindow) {
            return iframeElement;
         }
      }
      return null;
   }

   findPosY(object) {
      let top = 0;

      if (object.offsetParent) {
         while (object.offsetParent) {
            top += object.offsetTop;
            object = object.offsetParent;
         }
      }
      else if (object.y) {
         top += object.y;
      }
      return top;
   }

   // it is used for toast messages, do not comment again, it is used in iframe modes
   startOnIFrameScrollInterval(iframeElement) {
      this.onIFrameScrollMessageInterval = setInterval(
         () => {
            const iframeTop = this.findPosY(iframeElement);
            this.sendMessageToiFrame(iframeElement, "onIFrameScroll", {height: window.pageYOffset - iframeTop});
         },
         10000);
   }

   onInnerFrameChanged(parameters, sourceWindow) {
      console.log("onInnerFrameChanged message received, iframe height: " + parameters.height + "px");

      const iframeElement = this.getIframeElementFromSourceWindow(sourceWindow);
      if (iframeElement) {
         //We give some more space to ensure that the margins fit within the iframe.
         const height = Math.max(parameters.height, 200);
         iframeElement.height = height + "px";

         if (this.sendOnIFrameScrollMessage && !this.onIFrameScrollMessageInterval) {
            this.startOnIFrameScrollInterval(iframeElement);
         }
      }
   }

   onAnalyticsPageView(parameters) {
      // do not forget to set Analytics-ID in admin
      console.log("onAnalyticsPageView message received", JSON.stringify(parameters.data));
   }

   onAnalyticsAction(parameters) {
      // do not forget to set Analytics-ID in admin
      console.log("onAnalyticsAction message received", JSON.stringify(parameters.data));
   }

   isAuthorized(origin) {
      for (let index = 0; index < this.verifiedAuthorizedOrigin.length ; index++) {
         if (origin === this.verifiedAuthorizedOrigin[index]) {
            return true;
         }
      }

      for (let index = 0; index < this.authorizedOrigins.length ; index++) {
         if (origin === this.authorizedOrigins[index] ||
            this.authorizedOrigins[index] === "*") {
            if (this.verifiedAuthorizedOrigin.indexOf(origin) === -1) {
               this.verifiedAuthorizedOrigin.push(origin);
            }
            return true;
         }
      }

      return false;
   }

   receiveMessage(event) {
      if (!this.isAuthorized(event.origin)) {
         return;
      }

      this.processMessage(event.data.message, event.data.parameters, event.source);
   }

   sendMessageToiFrame(iframeElement, message, parameters) {
      console.log(">>> Sending message to iframe frame: " + message);
      if (iframeElement) {
         message = {
            message: message,
            parameters: parameters
         };
         let origins = this.verifiedAuthorizedOrigin;
         if (origins.length === 0) {
            origins = this.authorizedOrigins;
         }
         for (let index = 0; index < origins.length; index++) {
            iframeElement.contentWindow.postMessage(message, origins[index]);
         }
      }
   }

   processMessage(message, parameters, sourceWindow) {
      console.log("Processing message in main frame: " + message);

      if (message === "onInnerFrameChanged") {
         this.onInnerFrameChanged(parameters, sourceWindow);
      }
      else if (message === "onAnalyticsPageView") {
         this.onAnalyticsPageView(parameters);
      }
      else if (message === "onAnalyticsAction") {
         this.onAnalyticsAction(parameters);
      }
   }

   bind(authorizedOrigins) {
      this.authorizedOrigins = authorizedOrigins;
      if (!authorizedOrigins) {
         this.authorizedOrigins = ["*"];
      }

      this.verifiedAuthorizedOrigin = [];
      // it is used for toast messages, do not comment again, it is used in iframe modes
      this.sendOnIFrameScrollMessage = true;
      this.onIFrameScrollMessageInterval = null;

      this.messageEventListener =  (event) => {this.receiveMessage(event)};
      window.addEventListener("message", this.messageEventListener, false);
   }

   unbind() {
      if (this.onIFrameScrollMessageInterval) {
         window.clearInterval(this.onIFrameScrollMessageInterval);
      }

      window.removeEventListener("message", this.messageEventListener);
   }
}

let quickWinIframeMessageProcessor = null;

function bindQuickWin(authorizedOrigins) {
   if (quickWinIframeMessageProcessor) {
      quickWinIframeMessageProcessor.unbind();
   }

   quickWinIframeMessageProcessor = new QuickWinIframeMessageProcessor();
   quickWinIframeMessageProcessor.bind(authorizedOrigins);
}

let authorizedOrigins = ["https://qwint.llb.li", "https://qwint.llb.ch", "https://qwin.llb.li", "https://qwin.llb.ch"];
bindQuickWin(authorizedOrigins);